﻿$.fn.dxCtrlPdfViewer = function custom_dxCtrlPdfViewer(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpdfviewer dx-ctrl");
        this.createInstance(new cdxCtrlPdfViewer(this, option));
    }
    return this;
}

window.cdxCtrlPdfViewer = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty();

        popupFullScreen = $("<div/>").appendTo("body").dxCtrlPopupBase({
            fullScreen: true,
            showTitle: false,
            contentTemplate: function (contentElement) {
                contentElement.css("position", "relative")
                if (option.padding) contentElement.css("padding", option.padding)

                if (typeof option.allowClose == 'undefined' || option.allowClose) {
                    var padTop = contentElement.css("padding-top").replace("px", "")
                    var padRight = contentElement.css("padding-right").replace("px", "")
                    if (padTop < 24) { padTop = 50 } else { padTop = 0 }
                    if (padRight < 24) { padRight = 10 } else { padRight = 0 }
                    $("<div style='position:absolute;top:" + padTop + "px;right:" + padRight + "px;z-index:1;'/>").appendTo(contentElement).dxCtrlButton({
                        icon: "fas fa-times",
                        onClick: function (e) {
                            popupFullScreen.hide()
                        }
                    });
                }

                var jauge = $("<div/>").appendTo(contentElement).dxCtrlJauge({}).dxCtrlJauge("instance")
                jauge.mShow()

                $("<iframe src='" + option.urlPdf + "' style='height:100%;width:100%;border:none;'/>").appendTo(contentElement)

                window.setTimeout(function () { jauge.mHide(); }, 500)
            }
        }).dxCtrlPopupBase("instance")
        popupFullScreen.show()
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();
}